<router-outlet></router-outlet>
<ngx-snotifire></ngx-snotifire>
